import React from "react"
import styled from "styled-components"
import { useIntercom } from "react-use-intercom"
import { Theme } from "@pga/pga-component-library"

export const Link = styled.span`
  color: ${Theme.colors.lightBlue};
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

const ContactMembership = () => {
  const { show } = useIntercom()

  return (
    <p>
      Please try reloading the page, if the problem persists please{" "}
      <Link onClick={show}>click here</Link> to submit a support request.
    </p>
  )
}

export default ContactMembership
